import { PlanMetadataTypes } from '@mode/shared/contract-common';

/**
 * Helper functions to create planMetadataIds based on a token.
 *
 * Note - These helpers need to use typecasting directly to set the template literal return
 * types in the expected way. That means the line that sets up the id isn't actually validated
 * by the typescript. Just something to be aware of if you're making changes or refactoring
 * these helpers.
 */

export function makeQueryPlanMetadataId(queryToken: string): PlanMetadataTypes.QueryPlanMetadataId {
  return `${PlanMetadataTypes.PlanMetadataPrefixes.Query}-${queryToken}` as PlanMetadataTypes.QueryPlanMetadataId;
}

export function makeQueryWithCalcsPlanMetadataId(queryToken: string): PlanMetadataTypes.QueryWithCalcsPlanMetadataId {
  return `${PlanMetadataTypes.PlanMetadataPrefixes.QueryWithCalcs}-${queryToken}` as PlanMetadataTypes.QueryWithCalcsPlanMetadataId;
}

export function makeVizPlanMetadataId(vizToken: string): PlanMetadataTypes.VizPlanMetadataId {
  return `${PlanMetadataTypes.PlanMetadataPrefixes.Viz}-${vizToken}` as PlanMetadataTypes.VizPlanMetadataId;
}

export function makeVizDesignerPlanMetadataId(vizToken: string): PlanMetadataTypes.VizDesignerPlanMetadataId {
  return `${PlanMetadataTypes.PlanMetadataPrefixes.VizDesigner}-${vizToken}` as PlanMetadataTypes.VizDesignerPlanMetadataId;
}
